import React, { useState, useRef, useContext } from "react";

import MainDashboard from "../MainDashboard/MainDashboard";
import { useEffect } from "react";
import { io } from "socket.io-client";
import { serverInfo } from "../../../App";

const StarMainDashboard = () => {
  const [showContent, setShowContent] = useState(false);
  const [bankName, setBankName] = useState("");
  const { shoketUrl } = useContext(serverInfo);

  const socket = useRef();
  useEffect(() => {
    socket.current = io(shoketUrl);
    socket.current.emit("get_online_star", localStorage.getItem("auth_id"));

    window.addEventListener("beforeunload", (ev) => {
      ev.preventDefault();
      return alert("Are you sure you want to close?");
    });
  }, []);

  return (
    <>
      <MainDashboard />
    </>
  );
};

export default StarMainDashboard;
